import { defineComponent, ref } from 'vue'

import { MsHeadline } from '@sunrise/components'
import { MsClose, MsInformationCircle } from '@sunrise/icons'

export default defineComponent({
    name: 'MsTooltip',
    components: {
        MsInformationCircle,
        MsClose,
        MsHeadline,
    },
    setup() {
        const isVisible = ref(false)

        function toggleVisibility() {
            isVisible.value = !isVisible.value
        }

        function closeTooltip() {
            isVisible.value = false
        }

        return {
            toggleVisibility,
            closeTooltip,
            isVisible,
        }
    },
})
